import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'

// The server copies the linked document's `_id` and `code` onto the conversation when it is
// created or its linked-document identifier changes — never refreshed after that, so a
// hard-deleted or renamed document does not retroactively change what a conversation shows.
@ObjectType()
@InputType('ChatDocumentInput')
export class ChatDocument {
  @Field(() => ID)
  @Prop({ type: String, required: true })
  _id: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  code?: string
}
